// client/src/components/Routing/TerritoryWorkbench/WeekViz/WeekDayLegend.js
import { WEEKDAYS, WEEKDAY_COLORS } from './weekColors'

export default function WeekDayLegend ({
  dayStats, activeDay, setActiveDay, setHoverDay
}) {
  // hoverDay is only needed by the map layer (which fades non-hovered routes);
  // this component only writes via setHoverDay and reads activeDay for chip fade.
  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 6,
      background: 'rgba(251,248,241,0.94)', backdropFilter: 'blur(8px)',
      border: '1px solid #e0d8c2', borderRadius: 999, padding: '6px 8px',
      boxShadow: '0 4px 16px rgba(28,36,25,0.16)'
    }}>
      {WEEKDAYS.map((d, i) => {
        const on = activeDay === i
        const fade = activeDay != null && !on
        return (
          <button
            key={d.key}
            onClick={() => setActiveDay(on ? null : i)}
            onMouseEnter={() => setHoverDay(i)}
            onMouseLeave={() => setHoverDay(null)}
            title={`${d.full} · ${dayStats[i].stops} stops`}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 6, cursor: 'pointer',
              border: on ? `1.5px solid ${WEEKDAY_COLORS[i]}` : '1.5px solid transparent',
              background: on ? `${WEEKDAY_COLORS[i]}1f` : 'transparent',
              borderRadius: 999, padding: '4px 10px 4px 7px',
              fontFamily: 'inherit', transition: 'all 0.13s',
              opacity: fade ? 0.45 : 1
            }}
          >
            <span style={{
              width: 11, height: 11, borderRadius: '50%',
              background: WEEKDAY_COLORS[i],
              border: '1.5px solid #fff',
              boxShadow: '0 1px 2px rgba(0,0,0,0.2)', flexShrink: 0
            }} />
            <span style={{ fontSize: 12.5, fontWeight: 700, color: '#1c2419' }}>{d.short}</span>
            <span style={{ fontSize: 11, fontWeight: 600, color: '#97a094' }}>
              {dayStats[i].stops}
            </span>
          </button>
        )
      })}
      <div style={{ width: 1, height: 20, background: '#e0d8c2', margin: '0 2px' }} />
      <button
        onClick={() => setActiveDay(null)}
        title="Show all days"
        style={{
          padding: '4px 10px', borderRadius: 999, border: 'none', cursor: 'pointer',
          fontFamily: 'inherit', fontSize: 12, fontWeight: 600,
          background: activeDay == null ? '#e3eee0' : 'transparent',
          color: activeDay == null ? '#1f5e3a' : '#8a8472'
        }}
      >
        All
      </button>
    </div>
  )
}
